export default __webpack_public_path__ + "static/media/g10.b954a6e2.webp";